import { buildLiveSafetyCasePath } from '../../utils/acceptanceHierarchyNavigation';

export type InvestigateControlActionLike = {
  action_id?: string | null;
  title?: string | null;
  description?: string | null;
  status?: string | null;
};

export type InvestigateControlActionCollection = {
  active_actions?: InvestigateControlActionLike[] | null;
  completed_actions?: InvestigateControlActionLike[] | null;
};

export function pickSharedWorkflowControl(
  actions: InvestigateControlActionCollection | null | undefined,
): InvestigateControlActionLike | null {
  const active = Array.isArray(actions?.active_actions) ? actions?.active_actions || [] : [];
  const completed = Array.isArray(actions?.completed_actions) ? actions?.completed_actions || [] : [];
  return active[0] || completed[0] || null;
}

export function resolveInvestigateSafetyCaseId(input: {
  contextSafetyCaseId?: string | null;
  incident?: {
    safety_case_id?: string | null;
    finding_id?: string | null;
    safety_case?: { safety_case_id?: string | null; finding_id?: string | null } | null;
  } | null;
}): string {
  return String(
    input.contextSafetyCaseId
    || input.incident?.safety_case?.safety_case_id
    || input.incident?.safety_case?.finding_id
    || input.incident?.safety_case_id
    || input.incident?.finding_id
    || '',
  ).trim();
}

export function controlRecordedDescription(action: InvestigateControlActionLike | null | undefined): string {
  return String(action?.title || action?.description || '').trim();
}

/** Direct Controls tab with case context. No Safety Case search. */
export function buildSafetyCaseControlsPath(args: {
  safetyCaseId: string;
  orgId?: string | null;
  siteId?: string | null;
  workflowId?: string | null;
  incidentId?: string | null;
}): string {
  const safetyCaseId = String(args.safetyCaseId || '').trim();
  const base = buildLiveSafetyCasePath({
    caseId: safetyCaseId,
    orgId: args.orgId,
    siteId: args.siteId,
    workflowId: args.workflowId,
    incidentId: args.incidentId,
  });
  const [pathname, search] = base.split('?');
  const params = new URLSearchParams(search || '');
  params.set('tab', 'controls');
  params.set('safety_case_id', safetyCaseId);
  return `${pathname}?${params.toString()}`;
}

/** Direct Verify tab with exact Safety Case ID. No Investigate/verification list detour. */
export function buildSafetyCaseVerifyPath(args: {
  safetyCaseId: string;
  orgId?: string | null;
  siteId?: string | null;
  workflowId?: string | null;
  incidentId?: string | null;
}): string {
  const safetyCaseId = String(args.safetyCaseId || '').trim();
  const base = buildLiveSafetyCasePath({
    caseId: safetyCaseId,
    orgId: args.orgId,
    siteId: args.siteId,
    workflowId: args.workflowId,
    incidentId: args.incidentId,
  });
  const [pathname, search] = base.split('?');
  const params = new URLSearchParams(search || '');
  params.set('tab', 'verify');
  params.set('safety_case_id', safetyCaseId);
  return `${pathname}?${params.toString()}`;
}
